module.exports = __webpack_public_path__ + "img/prospect5.04e837b9.jpg";